import React, { useContext } from "react";
import BasicAccountApplicationAPI from "../../api/commercial/basic-account-application";
import { ApplicationFlowSteps } from "../../route/application/authenticated/application-flow/types";
import { ErrorContext } from "../../route/error/provider";
import CompanyMapper from "../home/company-mapper";
import { CompanyModel } from "../home/types";
import AdditionalBenefits from "./index";
import BasicAccountBenefitsMapper from "./mapper";
import { BasicAccountBenefitsModel } from "./types";
import { LanguageContext } from "../../context/languageContext";
import { ProductContext } from "../../context/product-context/productContext";
import { BasicAccountApplicationDocument } from "../../api/commercial/generated-types";

export default function AdditionalBenefitsAdapter({
  basicAccountApplication,
  triggerReload,
  setStep,
}: {
  basicAccountApplication: BasicAccountApplicationDocument;
  triggerReload: () => void;
  setStep: (step: ApplicationFlowSteps) => void;
}): React.JSX.Element {
  const basicApplicationRef = basicAccountApplication.applicationRef;

  const { selectedProduct } = useContext(ProductContext);

  const { language } = useContext(LanguageContext);

  const additionalBenefitsModel: BasicAccountBenefitsModel =
    BasicAccountBenefitsMapper.mapDocumentToPageModel(
      basicAccountApplication,
      language,
    );

  const companyModel: CompanyModel = CompanyMapper.mapDocumentToPageModel(
    basicAccountApplication.company,
  );

  const { setError } = useContext(ErrorContext);

  return (
    <AdditionalBenefits
      initial={additionalBenefitsModel}
      context={{
        companyName: companyModel.name,
      }}
      previous={() => {
        setStep(ApplicationFlowSteps.BASIC_ACCOUNT_INFORMATION);
      }}
      next={async (model: BasicAccountBenefitsModel) => {
        try {
          await BasicAccountApplicationAPI.requestBasicAccountBenefits(
            BasicAccountBenefitsMapper.mapPageModelToRequest(
              model,
              basicApplicationRef,
              selectedProduct?.productRef,
            ),
          );
        } catch (e) {
          setError(e);
        }

        triggerReload();
      }}
    />
  );
}
